import { ID } from '../../utils/codecUtils';
import { ProcessingDuration } from '../models/processingDuration';
import { processingDurationSchema } from '../models/processingDuration.schema';

export type ProcessingDurationPayload = ProcessingDuration;

export const patchProcessingDuration = (
  annotationId: ID,
  payload: ProcessingDurationPayload
) => {
  return {
    endpoint: `/annotations/${annotationId}/processing_duration`,
    method: 'PATCH',
    responseSchema: processingDurationSchema,
    payload,
    payloadSchema: processingDurationSchema,
  } as const;
};
